import { appPrefixed } from "util/URLUtils";
const isActiveRoute = (requestPath, path, end = void 0) => end ? requestPath === appPrefixed(path) : requestPath.indexOf(appPrefixed(path)) === 0;
export default isActiveRoute;
